import React from 'react';
import styled from 'styled-components';

import CategoryCard from './SubcategoryGalleryPaneCard';

const CategoryPane = ({ topCategory, categories, sewpatId }) => {
    const StyledCategoryPane = styled.div`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        
        & .gallery-pane-card {
          width: 25vw;
          max-width: 150px;
          min-width: 75px;
          margin: 0.75em 0 0;
        }

        @supports (display: grid) {
          display: grid;
          grid-template-columns: repeat(auto-fit,minmax(90px, 1fr));
          grid-gap: 0.75rem;

          & .gallery-pane-card {
            width: inherit;
            max-width: 150px;
            min-width: 75px;
            margin: 0;
          }
        }
    `;

    const buildCategoryCards = () => {
        const Cards = [];
        topCategory.categories.map(categoryID => {
            Cards.push(
                <CategoryCard
                    title={(categories[categoryID] || {}).title || ''}
                    thumbnail={(categories[categoryID] || {}).thumbnail || ''}
                    categoryid={categoryID}
                    sewpatId={sewpatId}
                />,
          );
        });
        return Cards;
    };

    return (
        <StyledCategoryPane>
            {buildCategoryCards()}
        </StyledCategoryPane>
    );
};

export default CategoryPane;



// WEBPACK FOOTER //
// ./src/components/categories/CategoryPane.js